import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { _zzsurvey_utils_make_date_now_plus_days } from "../utils/zz/zz-zzsurvey-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { useHandleInputChange } from "../hooks/useHandleInputChange";
import Btn from "./Btn";
import FormGenerator from "./FormGenerator";
import FormFieldGenerator from "./FormFieldGenerator";
import JSDisplayValue from "./JSDisplayValue";
import SpinnerClassic from "./SpinnerClassic";
import { useContext } from "react";
import { ZZTempSurveyContext } from "./ZZTempSurvey";


// DEFAULT COMPONENT
const ZZTempDialogSignConsent = (props) => {
  // TODO context for freshness
  const _context = useContext(ZZTempSurveyContext);
  let _context_freshness = -1;
  if (_context?.freshness > 0) {
    _context_freshness = _context.freshness;
  }
  //
  const {
    appState,
    cbRefresh,
    _zzsurvey_formDefiinitionSignConsent,
    // consents_arr,
    _extract_single_table_state,

    mode,
    jsxHeader,
    formDefinition, //
    // initialState,
    fetchingSubmit,
    cbSubmit,
    cbCancel,
    componentDidMount,
    _cb_survey_template_arr,
    cbFormState,
  } = props;
  //
  const global_freshness = useSelector(state => state.app.global_freshness);
  console.log('global_freshness', global_freshness);
  //
  /*
  let _formDefinition = formDefinition;
  if (typeof formDefinition === 'function') {
    _formDefinition = formDefinition();
  }
  */
  const consents_arr = _extract_single_table_state(appState, "TABLE_CONSENTS").data;
  let _formDefinition = _zzsurvey_formDefiinitionSignConsent(null, consents_arr);
  //
  /*
  const contextData = useContext(ZZTempSurveyContext);
  const app_freshness = contextData.freshness;
  console.log('app_freshness', app_freshness);
  */
  //
  let initialState = {};
  if (mode === 'ADD') {
    if (js_utils.is_object(props.initialState)) {
      initialState = { ...props.initialState };
    }
  }
  if (mode === 'EDIT') {
    if (js_utils.is_object(props.initialState)) {
      initialState = { ...props.initialState };
    }
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  const [freshness, setFreshness] = useState(0);
  //
  //
  let handleChange_2 = handleChange;
  if (typeof _cb_survey_template_arr === 'function') {
    handleChange_2 = (event) => {
      const cbCustomHandleChange = (state, name, value) => {
        if (name === "survey_template_id") {
          const survey_template_id = value;
          /*
          "name": "service_type",
          "options": ["Prodaja", "Servis"],
          */
          let _is_prodaja = true;
          let survey_template_arr = [];
          // if (typeof _cb_survey_template_arr === 'function') {
          survey_template_arr = _cb_survey_template_arr();
          // }
          survey_template_arr.forEach((item) => {
            if (item.survey_template_id === survey_template_id) {
              if (item.service_type === "Servis") {
                _is_prodaja = false;
              }
            }
          });
          if (_is_prodaja) {
            // DM 2025-03-31: Za prodaju- – prvi put se anketa šalje nakon 6 dana, drugi put nakon 11 dana od unosa exel tabele, i anketa je otvorena 20 dana od unosa exel tabele.
            return {
              ...state,
              survey_template_id,
              service_date: new Date().toISOString().substring(0, 10),
              date_to_send_first_email: _zzsurvey_utils_make_date_now_plus_days(6),
              date_to_send_second_email: _zzsurvey_utils_make_date_now_plus_days(11),
              date_due: _zzsurvey_utils_make_date_now_plus_days(20),
            }; // return custom mutated state
          } else {
            // DM 2025-03-31: Za servis – prvi put se anketa šalje nakon 2 dana, drugi put nakon 7 dana od unosa exel tabele, i anketa je otvorena 15 dana od unosa exel tabele.
            return {
              ...state,
              survey_template_id,
              service_date: new Date().toISOString().substring(0, 10),
              date_to_send_first_email: _zzsurvey_utils_make_date_now_plus_days(2),
              date_to_send_second_email: _zzsurvey_utils_make_date_now_plus_days(7),
              date_due: _zzsurvey_utils_make_date_now_plus_days(15),
            }; // return custom mutated state
          }
        } else {
          return false; // will be classic mutate
        }
        return false; // will be classic mutate
      };
      //
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      if (typeof cbCustomHandleChange === 'function') {
        let _newState = cbCustomHandleChange(state, name, value); // cbCustomHandleChange mutate state
        if (_newState === false) {
          // cbCustomHandleChange refuse to mutate state
          // classic mutate
          setState({
            ...state,
            [name]: value
          });
        } else {
          // cbCustomHandleChange mutated state
          setState(_newState);
        }
      } else {
        // classic mutate
        setState({
          ...state,
          [name]: value
        });
      }
    };
  }
  //
  //
  //
  useEffect(() => { // NOVO
    // auto refresh
    if (typeof cbRefresh === 'function') {
      cbRefresh();
    }
  }, []);
  //
  //
  useEffect(() => { // componentDidMount
    // auto cb
    if (typeof componentDidMount === 'function') {
      componentDidMount();
    }
    /*
    // auto refresh
    setTimeout(setFreshness(f => { return f + 1; }), 300);
    setTimeout(setFreshness(f => { return f + 1; }), 600);
    setTimeout(setFreshness(f => { return f + 1; }), 1200);
    setTimeout(setFreshness(f => { return f + 1; }), 2400);
    */
  }, []);
  //
  //
  let jsx2 = null;
  if (typeof cbFormState === 'function') {
    jsx2 = cbFormState(state);
  }
  //
  //
  return (
    <>
      {jsxHeader}

      <div className="zz-novo-form-simple">
        <FormGenerator
          formDefinition={_formDefinition}
          formState={state}
          formErrors={{}}
          handleChange={handleChange_2}
        />
      </div>
      {/*
      <div className="unicompo-dialog__btns unicompo-dialog__btns--sticky">
        <div className="unicompo-dialog__btns__btn-pack-vector">
          <div className="xi">
            {
              fetchingSubmit === true && (
                <SpinnerClassic />
              )
            }
          </div>
          <div className="xi">
            <Btn
              title='Submit'
              btnDialogSubmit
              handleClick={() => { cbSubmit(state); }}
              disabled={false}
            />
          </div>
          <div className="xi">
            <Btn
              outline
              btnDialogCancel
              title='Cancel'
              i='fa fa-times'
              handleClick={() => { cbCancel(); }}
            />
          </div>
        </div>
      </div>
      */}
      {jsx2}
    </>
  );
};

export default ZZTempDialogSignConsent;